<template>
  <el-row id="gitHubWorks">
    <el-row>
      <el-col :span="20" :push="2">
        <h5>GitHub</h5>
      </el-col>
      <el-col :span="2" :push="2">
        <a class="el-icon-arrow-right"
           href="https://github.com/curatorjin"
           target="_blank">更多</a>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="row-bg" justify="center" v-for="(item, index) in works" :key="index"
            v-if="index %3==0">
      <el-col :span="8" v-for="(repo,key) in works" :key="key" v-if="key - index <3 && key-index>=0">
        <el-card shadow="hover" class="gitWorkCard">
          <h5 style="height: 30px;" class="font-weight-bold" v-html="repo.name"></h5>
          <p style="height: 100px;" v-html="repo.desc"></p>
          <a v-bind:href="repo.link">去GitHub查看</a>
        </el-card>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'GitHub',
  data () {
    return {
      works: ''
    }
  },
  mounted: function () {
    this.getGit()
  },
  methods: {
    getGit: function () {
      this.$http.get('static/github_works.json').then(function (response) {
        this.works = response.data
      })
    }
  }
}
</script>

<style scoped>
  .row-bg {
    margin-top: 35px;
  }

  .gitWorkCard{
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/GitHub.vue